// Adapted from web/src/components/production-report/Tasks.js
import { Row, Col, Button } from "@commonsku/styles";
import React, { useEffect, useState } from "react";
import MentionTextarea from "../../MentionTextarea";
import { DisplayNote } from "../../../types";
import { useSelector, useDispatch } from "react-redux";
import { editNote } from "../../../redux/clientDetails";
import { mentionLinkToStr, toTitleCase } from "../../../utils";

export interface EditNoteDialogProps {
    note: DisplayNote
    isDisplayed: (display: boolean) => void
}

type UsersByIdState = {
    entities: {
        users: Record<string, { mask?: string }>
    }
};

export const EditNoteDialog = ({
    note,
    isDisplayed,
}: EditNoteDialogProps) => {
    const [text, setText] = useState<string>('');
    const dispatch = useDispatch();
    const usersById = useSelector((state: UsersByIdState) => state.entities.users);

    useEffect(() => {
        mentionLinkToStr((note.message || '').replace(/<br(( )?\/)?>/g, ''), usersById).then((res: string) => {
            setText(res);
        });
    }, [note, usersById]);

    const mentionUsers = useSelector((state: any) =>
        Object.values(state.entities.users)
            .filter((user: any) => user.mask && user.mask !== '')
    );

    const handleEditNote = (note: DisplayNote, text: string) => {
        isDisplayed(false);
        dispatch(editNote({
            current_note: note,
            text: text
        }));
    };

    return (
        <Row>
            <Col padded xs>
                <MentionTextarea placeholder={toTitleCase(note.type)}
                    value={text || ''} mention_users={mentionUsers}
                    onChange={setText}
                    style={{ maxWidth: '100%' }}
                />
            </Col>
            <Col padded xs>
                <Button onClick={() => handleEditNote(note, text)} size="medium">Save</Button>
            </Col>
        </Row>
    );
};
